import { Directive, ElementRef, HostBinding, Input } from '@angular/core';

export enum InputTypes {
  TEXT = 'text',
  PASSWORD = 'password',
}

export enum AvailableStyles {
  lg,
  xs,
  bb,
}

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'input[UIKitInput], textarea[UIKitInput]',
})
export class InputDirective {
  @Input() styles: string[] = [];

  @HostBinding('class')
  get classes() {
    return (
      (this.autoWidth ? 'w-auto ' : '') +
      `input ${this.styles.map((style: string) => `input_${style}`).join(' ')}`
    );
  }

  @Input()
  set hideSymbols(value: boolean) {
    const el = this._elementRef.nativeElement;
    el.type = value ? InputTypes.PASSWORD : InputTypes.TEXT;
  }

  // @ts-expect-error
  @Input() autoWidth: boolean;

  constructor(private _elementRef: ElementRef) {}
}
